angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/project.html',
    '<!-- Project -->\n' +
    '<update-title title="Contract {{project.license.Label}} Job In {{project.City|capitalize}} | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="(Posted {{project.posted}}) {{project.Description| trimText:true:285:\' ...\'}}"></update-meta>\n' +
    '<update-meta itemprop="description" content="{{project.Description}}"></update-meta>\n' +
    '<update-meta property="og:title" content="Contract {{project.LicenseLabel}} Job In {{project.City}}"></update-meta>\n' +
    '<section class="content dashboard">\n' +
    '    <div class="container">\n' +
    '        <div class="row" ng-if="project && project._proposalChecked">\n' +
    '            <!-- Only render if we have a project loaded -->\n' +
    '            <div ng-cloak ng-class="{\'col-xs-12 col-sm-5 col-sm-push-7 request-proposals\': user && user.IsClient, \'col-xs-12 col-sm-5 col-sm-push-7 project-messages\': !user || user.IsProfessional}">\n' +
    '                <!-- Breadcrumbs -->\n' +
    '                <div class="breadcrumbs" ng-class="{\'breadcrumbs-padding\': user && user.IsClient && user.Id==project.UserId}">\n' +
    '                    <a ng-show="previousPage" href="" ng-click="$state.go(previousPage.state)">{{previousPage.label}}</a>\n' +
    '                    <i class="fa fa-chevron-right"></i>\n' +
    '                    <span style="word-wrap: break-word;">{{project.Title}}</span>\n' +
    '                </div>\n' +
    '                <client-proposal-list ng-if="user && user.IsClient && user.Id==project.UserId"></client-proposal-list>\n' +
    '                <project-client ng-if="!user || user.IsProfessional || (user.IsClient && user.Id!=project.UserId) "></project-client>\n' +
    '                <hr>\n' +
    '                <create-proposal ng-if="!user || (user.IsProfessional && !alreadyMadeProposal())"></create-proposal>\n' +
    '                <view-small-proposal ng-if="user && user.IsProfessional && alreadyMadeProposal()"></view-small-proposal>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-7 col-sm-pull-5" ng-cloak>\n' +
    '                <h2 style="word-wrap: break-word;">{{project.Title}}</h2>\n' +
    '                <!-- Table -->\n' +
    '                <div class="dashboard-box">\n' +
    '                    <!-- Alert -->\n' +
    '                    <div class="alert alert-warning" role="alert" ng-show="user && user.IsProfessional && project.HiredUserId != user.Id && project.HiredUserId && alreadyMadeProposal()">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        <strong>We\'re sorry!</strong> The proposal you sent was not selected.\n' +
    '                        <br class="hidden-sm hidden-xs"> {{client.FullName}} hired another candidate for this project.\n' +
    '                    </div>\n' +
    '                    <div class="alert alert-warning" role="alert" ng-show="user && user.IsProfessional && !project.HiredUserId && project.Status == \'closed\' && alreadyMadeProposal()">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        <strong>We\'re sorry!</strong> The proposal you sent was not selected.\n' +
    '                        <br class="hidden-sm hidden-xs"> {{client.FullName}} closed the project.\n' +
    '                    </div>\n' +
    '                    <div class="alert project-closed alert-success" role="alert" ng-show="user && user.IsProfessional && project.HiredUserId == user.Id && project.HiredUserId">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        <strong>Congratulations!</strong> You\'ve been hired for the project!\n' +
    '                        <br class="hidden-sm hidden-xs">The project status now is changed to Closed.\n' +
    '                    </div>\n' +
    '                    <div class="alert project-closed alert-success" role="alert" ng-show="user && user.IsClient && user.Id == project.UserId && project.HiredUserId">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        Congratulations! You have hired {{hired}} for your project. An email notification has been sent to the engineer.\n' +
    '                    </div>\n' +
    '                    <!--\n' +
    '                    <div class="alert project-closed alert-success oneline" role="alert" ng-show="project.Status ==\'closed\'">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        Project is closed, thank you!\n' +
    '                    </div>\n' +
    '                    -->\n' +
    '\n' +
    '                    <span class="pull-right">\n' +
    '                        <a ng-click="shareProject()" class="btn btn-default btn-share btn-projects"  href="">Share</a><br class="hidden-xs hidden-sm">\n' +
    '                        <a ng-click="closeProject()" ng-show="user && user.IsClient && user.Id==project.UserId && project.Status !=\'closed\' && project.Status !=\'pendingReview\'" class="btn btn-default mb20 btn-projects" href="" >Close</a>\n' +
    '                        <a class="btn btn-default mb20 btn-projects" href="" ng-show="user && user.IsProfessional && project.Status==\'open\' && hidePass === false" ng-click="ignoreProject()">Ignore</a>\n' +
    '                    </span>\n' +
    '\n' +
    '\n' +
    '                    <div class="pull-right mb20">\n' +
    '                        <!-- <a class="btn btn-default">Pass</a>-->\n' +
    '                    </div>\n' +
    '                    <table class="table table-bordered table-striped border-up">\n' +
    '                        <tbody>\n' +
    '                            <tr>\n' +
    '                                <td>\n' +
    '                                    <i class="fa fa-circle fa-fw" ng-style="{\'color\':project.status.color}"></i>Project Status</td>\n' +
    '                                <td>\n' +
    '                                    <strong>{{project.status.label}}</strong>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td>\n' +
    '                                    <i class="fa fa-map-marker fa-fw"></i>Project Location</td>\n' +
    '                                <td>\n' +
    '                                    <strong>{{addressString}}{{project.City|capitalize}}, {{project.StateLicense}}</strong>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td>\n' +
    '                                    <i class="fa fa-wrench fa-fw"></i>Type of Engineer</td>\n' +
    '                                <td>\n' +
    '                                    <strong>{{project.license.Label}}</strong>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td>\n' +
    '                                    <i class="fa fa-calendar-check-o fa-fw"></i>Date Posted</td>\n' +
    '                                <td>\n' +
    '                                    <strong>{{project.CreatedDate | localeDateHuman}}</strong>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            <tr>\n' +
    '                                <td>\n' +
    '                                    <i class="fa fa-calendar fa-fw"></i>Complete By</td>\n' +
    '                                <td>\n' +
    '                                    <strong>{{project.WorkCompletedBy | workCompletedBy: project.WorkCompletedByDate}}</strong>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '                <!-- Text -->\n' +
    '                <div class="dashboard-box">\n' +
    '                    <h4>Project Description</h4>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-12 col-md-11 project-descr" style="word-wrap: break-word; white-space: pre-wrap;">{{project.Description}}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!-- Attachment -->\n' +
    '                <div class="dashboard-box" ng-show="project.Attachment">\n' +
    '                    <h4>Attachment</h4>\n' +
    '                    <div class="project-docs">\n' +
    '                        <ul class="list-group bullets-a-style alt">\n' +
    '                            <li class="list-group-item">\n' +
    '                                <a ng-href="{{project.Attachment.Url}}" target="_blank" download>{{project.Attachment.Name}}</a>\n' +
    '                            </li>\n' +
    '                            <br>\n' +
    '                            <a ng-show="project.AttachmentPreview" ng-href="{{project.Attachment.Url}}" target="_blank" download>\n' +
    '                                <img style="max-width: 100%; max-height: 100%;" ng-src="{{project.AttachmentPreview.Url}}">\n' +
    '                            </a>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!-- Questions -->\n' +
    '                <div class="dashboard-box">\n' +
    '                    <h4 id="Questions">Questions and Answers</h4>\n' +
    '                    <div>\n' +
    '                        <div ng-repeat="question in question.list" class="question-container">\n' +
    '                            <div class="question-body">\n' +
    '                                <div>\n' +
    '                                    <strong>Q:&nbsp;</strong>\n' +
    '                                    <span>{{question.Question}}</span>\n' +
    '                                </div>\n' +
    '                                <div class="question-meta">\n' +
    '                                    <span>{{question.EngineerName}} - {{formatDate(question.CreatedDate)}}</span>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                            <div ng-if="question.Answered || amIProjectOwner()" class="question-answer">\n' +
    '                                <div>\n' +
    '                                        <strong>A:&nbsp;</strong>\n' +
    '                                        <span ng-if="question.Answered">{{question.Answer}}</span>\n' +
    '                                        <a ng-if="!question.Answered && amIProjectOwner()" href="" ng-click="replyQuestion(question.Id)">[REPLY]</a>\n' +
    '                                </div>\n' +
    '                                <div ng-if="question.Attachments.length">\n' +
    '                                    <strong>File Attachments:&nbsp;</strong>\n' +
    '                                    <div ng-repeat="att in question.Attachments track by att.Id">\n' +
    '                                        <a href="{{att.Key.Url}}" target="_blank">{{att.Name}}</a>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                                <div ng-if="question.Answered" class="question-meta">\n' +
    '                                    <span>{{question.ClientName}} - {{formatDate(question.AnswerCreatedDate)}}</span>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="isProjectActive() && !user" class="alert over-limit alert-warning mt40" role="alert">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        <a href="" ng-click="signUp()">\n' +
    '                            Sign up</a>\n' +
    '                        or\n' +
    '                        <a href="" ng-click="logIn()">Log in</a>\n' +
    '                        to ask a question.\n' +
    '                    </div>\n' +
    '                    <div ng-if="!isProjectActive()" class="alert over-limit alert-warning" role="alert">\n' +
    '                        <a class="close" data-dismiss="alert" aria-label="Close"></a>\n' +
    '                        You can\'t ask questions because of the project\'s current status.\n' +
    '                    </div>\n' +
    '                    <form id="questionForm" name="form.questionForm" ng-submit="confirmSubmitQuestion()">\n' +
    '                        <div class="mt40">\n' +
    '                            <span class="pull-right">\n' +
    '                                <small>char. remaining:</small>\n' +
    '                                <strong>{{question.remainingCharacters}}</strong>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                        <textarea ng-disabled="isQuestionFormDisabled()" ng-model="question.text" required="true" name="questionText" class="form-control"\n' +
    '                        rows="4" placeholder="ASK A QUESTION..." ng-keydown="updateQuestionCharLeft()" ng-keyup="updateQuestionCharLeft()"></textarea>\n' +
    '                        <div class="help-block" ng-class="{ \'errors\': form.questionForm.questionText.$touched && (form.questionForm.questionText.$invalid || question.text.length>maxQuestionsChar) }"\n' +
    '                        ng-messages="form.questionForm.questionText.$error" ng-if="form.questionForm.questionText.$touched">\n' +
    '                            <p ng-message="required">This field is required</p>\n' +
    '                            <p ng-if="question.text.length > maxQuestionsChar">This field is too long.</p>\n' +
    '                        </div>\n' +
    '                        <small>Including any contact info is prohibited</small>\n' +
    '                        <div class="text-right mt10">\n' +
    '                            <button type="submit" ng-disabled="form.questionForm.$invalid || question.text.length>maxQuestionsChar" class="btn btn-primary">Send</button>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '<script type="text/ng-template" id="modal-close.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Close Project</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            <span ng-show="project.Status == \'open\'">You have not hired an Engineer. Are you sure you want to close this project?</span>\n' +
    '            <span ng-show="project.Status != \'open\'">Close this project?</span>\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-click="agreed()" class="btn btn-primary">Yes</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-share-project.html">\n' +
    '    <div class="modal-header">\n' +
    '            <a class="close" ng-click="$close()" data-dismiss="modal" aria-label="Close"><i class="fa fa-times"></i></a>\n' +
    '            <h4 class="modal-title">Share</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-body">\n' +
    '            <ul class="list-inline mb20">\n' +
    '                <li><a ng-href={{linkedInUrl}} target="_blank" class="fa fa-linkedin-square fa-3x"></a></li>\n' +
    '                <li><a ng-href={{facebookUrl}} target="_blank" class="fa fa-facebook-square fa-3x"></a></li>\n' +
    '                <li><a ng-href={{twitterUrl}} target="_blank" class="fa fa-twitter-square fa-3x"></a></li>\n' +
    '            </ul>\n' +
    '            <p>\n' +
    '                <small>Copy Project URL</small>\n' +
    '            </p>\n' +
    '            <!-- Fieled -->\n' +
    '            <div class="input-group" style="width:100%;">\n' +
    '                <input class="form-control input-lg" ng-value="project._urlToShare" id="projectUrlShare" type="text">\n' +
    '                <span data-clipboard-target="#projectUrlShare" uib-tooltip="Copied!" tooltip-is-open="popUp" tooltip-trigger="none" tooltip-placement="bottom"\n' +
    '                    class="input-group-addon" id="btnClipboardShare" ng-click="open()"><i class="fa fa-copy fa-lg">\n' +
    '                    </i>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <button ng-click="$close()" type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n' +
    '        </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-pass.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Pass Project</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Pass this project?\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-click="agreed()" class="btn btn-primary">Yes</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-question-sent.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Your question has been sent to the client.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-question-answer.html">\n' +
    '    <form name="form.answerForm" novalidate autocomplete="off" ng-submit="submitAnswer()">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Reply</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-body">\n' +
    '            <div class="">\n' +
    '                <span class="pull-right">\n' +
    '                    <small>char. remaining:</small>\n' +
    '                    <strong>{{remainingCharacters}}</strong>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '            <textarea ng-model="answerText" required="true" name="answerText" class="form-control"\n' +
    '            rows="4" placeholder="ANSWER QUESTION..." ng-change="updateCharactersLeft()"></textarea>\n' +
    '            <div class="help-block" ng-class="{ \'errors\': form.answerForm.answerText.$touched && (form.answerForm.answerText.$invalid||answerText.length>maxAnswerLength) }"\n' +
    '            ng-messages="form.answerForm.answerText.$error" ng-if="form.answerForm.answerText.$touched">\n' +
    '                <p ng-message="required">This field is required</p>\n' +
    '                <p ng-if="answerText.length>maxAnswerLength">This field is too long.</p>\n' +
    '            </div>\n' +
    '            <small>Including any contact info is prohibited</small>\n' +
    '            <div>\n' +
    '                <div class="row mt10">\n' +
    '                    <div class="col-sm-4 col-md-3 mt5">\n' +
    '                        <span class="btn btn-primary btn-file">\n' +
    '                            <i class="fa fa-paperclip fa-lg"></i>\n' +
    '                            &nbsp;Attach File\n' +
    '                            <input type="file" name="file" ngf-select ngf-keep="\'distinct\'" ngf-max-files="{{maxAttachmentFiles}}"\n' +
    '                                multiple ng-model="files" ngf-max-size="20MB" ngf-validate="{size: {max: \'20MB\'}}"\n' +
    '                                class="btn btn-default" ngf-pattern="{{acceptedFileFormats}}" ng-disabled="isUploading">\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-mb-7">\n' +
    '                        <!-- Hide on opening -->\n' +
    '                        <div id="file-attached" class="" ng-repeat="file in files track by file.name">\n' +
    '                            <small style="word-wrap: break-word;">{{file.name}}</small>\n' +
    '                            <a href="javascript:;" class="trash" ng-click="removeFile(file)"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': form.answerForm.file.$invalid }" ng-messages="form.answerForm.file.$error">\n' +
    '                        <div ng-message="maxSize">\n' +
    '                            <p>File is too large, it must be smaller than 20 Mb</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="pattern">\n' +
    '                            <p>File format must be {{acceptedFileFormats}}</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="maxFiles">\n' +
    '                            <p>You can attach up to {{maxAttachmentFiles}} files</p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Cancel</button>\n' +
    '            <button type="submit" ng-disabled="form.answerForm.$invalid || answerText.length>maxAnswerLength || isUploading" class="btn btn-default">\n' +
    '                <span ng-show="isUploading && files.length">{{uploadPercentage}}% Sent</span>\n' +
    '                <span ng-show="!isUploading || files.length==0">Send</span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-answer-sent.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Your answer has been sent to the engineer.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-question-confirm.html">\n' +
    '    <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="close()" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '        </div>\n' +
    '    <div class="modal-body row">\n' +
    '        <div class="col-xs-1">\n' +
    '            <input type="checkbox" ng-model="data.confirmed" id="confirm-question-id"/>\n' +
    '            <label for="confirm-question-id"><span></span></label>\n' +
    '        </div>\n' +
    '        <p class="col-xs-11">\n' +
    '            I acknowledge that I have not included or requested any contact information in my question,\n' +
    '            such as name, company name, email address, URL, or phone number. Nor have I included any form of a bid.\n' +
    '            Doing so will result in the termination of your account.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="close()" class="btn btn-default">Close</button>\n' +
    '        <button type="button" ng-click="send()" class="btn btn-primary" ng-disabled="!data.confirmed">Send</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-answer-confirm.html">\n' +
    '    <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="close()" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '        </div>\n' +
    '    <div class="modal-body row">\n' +
    '        <div class="col-xs-1">\n' +
    '            <input type="checkbox" ng-model="data.confirmed" id="confirm-question-id"/>\n' +
    '            <label for="confirm-question-id"><span></span></label>\n' +
    '        </div>\n' +
    '        <p class="col-xs-11">\n' +
    '            I acknowledge that I have not included or requested any contact information in my answer,\n' +
    '            such as name, company name, email address, URL, or phone number. Contact information will\n' +
    '            be made available after the engineer has submitted the initial bid or estimate.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="close()" class="btn btn-default">Close</button>\n' +
    '        <button type="button" ng-click="send()" class="btn btn-primary" ng-disabled="!data.confirmed">Send</button>\n' +
    '    </div>\n' +
    '</script>');
}]);
